var parent = require('../../es/object/get-own-property-descriptors');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-descriptors.js
// module id = 1128
// module chunks = 0